export const MAX_RETRY_REFRESHING = 3;
export const REFRESH_TOKEN_URL = 'users/token/refresh';
export const LOGIN_URL = 'users/login';
export const LOGOUT_URL = 'users/logout';
export const PASSWORD_URL = 'users/password';
